// extracted by mini-css-extract-plugin
module.exports = {"main":"Cgv_main__Z2HlF","container":"Cgv_container__33cZq","title":"Cgv_title__b4ORV","description":"Cgv_description__ea1nS"};